import type { GraphUserProfile, UserTemplateData } from "@/shared/types";

/**
 * Converte um perfil do Microsoft Graph para o formato `UserTemplateData`
 * usado pelo cache e pelos templates de assinatura.
 *
 * Mapeia só identidade e cargo. Telefone fixo e endereço são institucionais
 * (`GENERAL_DATA`) — não vêm do Graph, senão o atributo do Azure AD do
 * usuário (em geral vazio ou desatualizado) sobrescreveria o padrão mesmo
 * sem o administrador ter liberado edição.
 *
 * @param profile - Perfil retornado pela Microsoft Graph API.
 * @returns Dados parciais do usuário no formato do template.
 *
 * @example
 * const data = mapGraphProfileToUserData(graphProfile);
 */
export function mapGraphProfileToUserData(profile: GraphUserProfile): Partial<UserTemplateData> {
  return {
    display_name: [profile.givenName, profile.surname].filter(Boolean).join(" ") || profile.displayName || "",
    first_name: profile.givenName || "",
    last_name: profile.surname || "",
    email: profile.mail || "",
    job_title: profile.jobTitle || "",
    mobile_phone: profile.mobilePhone || "",
  };
}
